import { connect } from 'react-redux';

import { PROPERTY_DETAILS_TYPE_GENERAL } from 'legacy/appstore/constants';

import { propertyViewDetails, propertyViewSources } from 'actions/property';

import { getPropertyVisibleDetailsType } from 'selectors/property';
import { getIsEffectiveDateReport } from 'selectors/property-explorer';
import { getEffectiveDateTimelineSubjectDetailsMissing } from 'selectors/effective-date';

import PropertyDetailsSection from 'legacy/components/PropertyDetailsSection';

const mapStateToProps = (state, ownProps) => {
  const { addressId } = ownProps;
  return {
    isEffectiveDateReport: getIsEffectiveDateReport(state),
    timelineSubjectDetailsMissing:
      getEffectiveDateTimelineSubjectDetailsMissing(state),
    title: 'Property Details',
    tooltipCopy:
      'HouseCanary is pulling these property details from MLS and public tax records. When conflicting data appears across different sources, we evaluate how recently the data was updated for each source and determine which source is most reliable, which can vary depending on the home characteristic in question. To see all sources, toggle the tab to ‘Data Sources.’',
    visiblePropertyDetailsType: getPropertyVisibleDetailsType(addressId)(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { addressId } = ownProps;
  return {
    onChangeVisiblePropertyDetails: (visiblePropertyDetailsType) =>
      visiblePropertyDetailsType === PROPERTY_DETAILS_TYPE_GENERAL
        ? dispatch(propertyViewDetails(addressId))
        : dispatch(propertyViewSources(addressId))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyDetailsSection);
